import React, { useState } from 'react'

import {
  Box,
  Button,
  Grid,
  Paper,
  TextField,
  Typography,
} from '@material-ui/core'

import { ConfirmationDialog, FileUploadInput, Label } from 'components'

import useSnackbar from 'hooks/useSnackbar'

import helpers from 'helpers'
import * as service from 'service'
import { FormContext, useForm } from 'react-hook-form'

const RiskAssumedInfo = ({
  incident,
  isShow,
  refresh,
  step,
  successMessage,
  message,
  buttonText,
  confirmMessage,
}) => {
  const [openConfirmationDialog, setOpenConfirmationDialog] = useState(false)

  const snackbar = useSnackbar()

  const formMethods = useForm({
    defaultValues: {
      riskAssumptionAttachments:
        incident?.riskAssumptions?.[step]?.attachments || [],
    },
  })

  const handleOpenConfirmationDialog = () => setOpenConfirmationDialog(true)

  const handleCancelRiskAssumption = async () => {
    try {
      await service.dponet.incidentRiskAssumptions.changeRiskAssumed({
        incidentId: incident?.id,
        id: incident?.riskAssumptions?.[step]?.id,
      })

      snackbar.open({
        message: successMessage,
        variant: 'success',
      })

      setOpenConfirmationDialog(false)
      refresh()
    } catch (error) {
      snackbar.open({
        message:
          helpers.formatters.errorMessage(error) ||
          'Ocorreu um erro, tente novamente',
        variant: 'error',
      })
    }
  }

  return (
    <>
      <Paper component={Box} p={2} mb={2}>
        <Typography variant="body1" gutterBottom>
          {message}
        </Typography>

        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Label title="Justificativa">
              <TextField
                variant="outlined"
                color="primary"
                type="text"
                value={incident?.riskAssumptions?.[step]?.justification || ''}
                minRows={3}
                multiline
                fullWidth
                disabled
              />
            </Label>
          </Grid>
          <Grid item xs={12}>
            <Label title="Anexos" paddingBoxTitle={0}>
              <FormContext {...formMethods}>
                <FileUploadInput
                  title="Anexos"
                  controlName="riskAssumptionAttachments"
                  hasDownloadFile
                  controllerBar
                  multiple
                  disabled
                />
              </FormContext>
            </Label>
          </Grid>
          <Grid item xs={12}>
            <Box textAlign="right">
              <Button
                variant="contained"
                color="secondary"
                onClick={handleOpenConfirmationDialog}
                disabled={isShow}
              >
                {buttonText}
              </Button>
            </Box>
          </Grid>
        </Grid>
      </Paper>
      <ConfirmationDialog
        open={openConfirmationDialog}
        setOpen={setOpenConfirmationDialog}
        text={confirmMessage}
        textButton="Confirmar"
        actionAcceptButton={handleCancelRiskAssumption}
      />
    </>
  )
}

export default RiskAssumedInfo
